import ClassicAuthModalBody from "components/loginReg/ClassicAuthModalBody";
import StreamlinedAuthModalBody from "components/loginReg/StreamlinedAuthModalBody";
import { AUTH_UI_THEMES } from "configs/authUiTheme";

export const LOGIN_REG_THEME_REGISTRY = {
  [AUTH_UI_THEMES.CLASSIC]: {
    key: AUTH_UI_THEMES.CLASSIC,
    modalClassName: "loginRegModal--classic",
    AuthModalBody: ClassicAuthModalBody,
  },
  [AUTH_UI_THEMES.STREAMLINED]: {
    key: AUTH_UI_THEMES.STREAMLINED,
    modalClassName: "loginRegModal--streamlined",
    AuthModalBody: StreamlinedAuthModalBody,
  },
};

export function resolveLoginRegTheme(themeKey, registry = LOGIN_REG_THEME_REGISTRY) {
  if (themeKey && registry[themeKey]) {
    return registry[themeKey];
  }
  return registry[AUTH_UI_THEMES.CLASSIC];
}
